<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-26 09:26:13
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-30 11:56:14
 * @Description: 客户案例列表页
-->
<template>
  <div class="cases-page bg-#f6f8fd min-h-screen">
    <!-- Header/Banner -->
    <div
      class="cases-header py-180px text-center bg-white lt-sm:py-160px bg-cover bg-center bg-no-repeat"
    >
      <div class="landing-container">
        <h1 class="font-s-48px text-#000000 pf-sc-semibold lt-sm:font-s-64px">
          真实案例 · 落地验证
        </h1>
        <p class="font-s-18px mt-16px text-main/70 pf-sc-regular lt-sm:mt-12px lt-sm:font-s-26px">
          已服务多家物业项目，覆盖住宅/商业/老旧小区等全业态，以数据化成果证明智慧物业的真实价值
        </p>
      </div>
    </div>

    <!-- Cases List -->
    <div class="landing-container py-60px lt-sm:py-120px lt-sm:px-32px">
      <div class="grid grid-cols-3 gap-24px lt-sm:grid-cols-1 lt-sm:gap-32px">
        <solution-case-summary-card
          v-for="(item, index) in pagedCases"
          :key="item.id"
          :title="item.title"
          :cover="item.cover"
          :tags="item.tags"
          :logo="item.logo"
        />
      </div>

      <!-- Pagination -->
      <div class="pagination-wrapper mt-60px flex justify-center lt-sm:mt-80px">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          layout="prev, pager, next, jumper, ->, slot"
          background
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <section-cta />
  </div>
</template>

<script setup lang="ts">
  import { caseSummaries } from '@/constants/case-studies'

  // Pagination
  const currentPage = ref(1)
  const pageSize = ref(12)
  const total = computed(() => caseSummaries.length)

  const pagedCases = computed(() => {
    const start = (currentPage.value - 1) * pageSize.value
    const end = start + pageSize.value
    return caseSummaries.slice(start, end)
  })

  const handlePageChange = () => {
    const isMobile = window.innerWidth < 768
    window.scrollTo({ top: isMobile ? 350 : 450, behavior: 'smooth' })
  }

  useSeoMeta({
    title: '客户案例 - 绘家科技',
    description: '绘家科技智慧物业解决方案标杆案例，展示数字化转型成果与客户价值。',
    keywords: '智慧物业案例,物业管理系统案例,智慧社区案例,绘家科技客户',
    ogTitle: '客户案例 - 绘家科技',
    ogDescription: '绘家科技智慧物业解决方案标杆案例，展示数字化转型成果与客户价值。',
    ogImage: '/logo.png',
  })
</script>

<style scoped>
  .cases-header {
    background-image: url('@/assets/images/solution-cases-bg.jpg');
  }

  :deep(.el-pagination) {
    @apply lt-sm:gap-[8px];
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
    justify-content: center;
  }

  :deep(.el-pagination button),
  :deep(.el-pagination .el-pager li) {
    @apply lt-sm:min-h-[64px] lt-sm:h-[64px] lt-sm:font-s-24px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 14px;
    color: #64748b;
    min-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
  }

  :deep(.el-pagination button:not(:disabled):not(.disabled):hover),
  :deep(.el-pagination .el-pager li:not(:disabled):not(.disabled):hover) {
    border-color: #0f67f8 !important;
    color: #0f67f8 !important;
  }

  :deep(.el-pagination .el-pager li.is-active) {
    background-color: #0f67f8 !important;
    border-color: #0f67f8 !important;
    color: #ffffff !important;
  }

  :deep(.el-pagination button:disabled),
  :deep(.el-pagination button.disabled),
  :deep(.el-pagination .el-pager li.disabled) {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #ffffff !important;
    border-color: #e2e8f0 !important;
    color: #64748b !important;
  }

  :deep(.el-pagination.is-background .btn-prev),
  :deep(.el-pagination.is-background .btn-next) {
    background-color: #ffffff !important;
    margin: 0 !important;
  }

  :deep(.el-pagination.is-background .el-pager li) {
    margin: 0 4px !important;
  }

  :deep(.el-pagination .el-icon) {
    @apply lt-sm:font-s-24px;
    font-size: inherit;
  }

  :deep(.el-pagination .el-pagination__jump) {
    @apply lt-sm:font-s-22px lt-sm:ml-18px lt-sm:gap-8px;
    margin-left: 24px;
    font-size: 14px;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  :deep(.el-pagination .el-pagination__jump .el-input) {
    @apply lt-sm:w-[80px]!;
    width: 56px !important;
    margin: 0 !important;
  }

  :deep(.el-pagination .el-pagination__jump .el-input .el-input__wrapper) {
    @apply lt-sm:h-[64px]!;
    box-shadow: none !important;
    border: 1px solid #e2e8f0 !important;
    padding: 0 !important;
    height: 40px !important;
    border-radius: 4px !important;
  }

  :deep(.el-pagination .el-pagination__jump .el-input .el-input__wrapper.is-focus) {
    border-color: #0f67f8 !important;
  }

  :deep(.el-pagination .el-pagination__jump .el-input input) {
    @apply lt-sm:font-s-24px!;
    text-align: center !important;
    font-size: 14px !important;
    color: #091221 !important;
    height: 100% !important;
  }

  @screen lt-sm {
    :deep(.el-pagination .el-pagination__jump .el-pagination__goto),
    :deep(.el-pagination .el-pagination__jump .el-pagination__classifier) {
      margin: 0;
    }
  }
</style>
